import {isNumeric} from 'rxjs/util/isNumeric';
import {DateUtilities} from '../../shared/utilities/date-utilities.model';
import {DeliveryAttachedNemoModel} from './delivery-attachments.model';
import {Utilities} from '../../shared/utilities/utilities.model';

export class Alert {
	date_last_update: string;
	date_rec_ins: string;
	date_read: string;
	flag_active: string;
	id_order: number;
	id_order_message: string;
	id_sender_ext: string;
	id_thread: string;
	txt_category: string;
	txt_context: string;
	txt_customdata_json: any;
	txt_detail: string;
	txt_chassis: string;
	txt_direction: string;
	txt_message: string;
	txt_plate: string;
	txt_subject: string;
	txt_sender_ext: string;
	user_last_update: string;
	user_rec_ins: string;
	attachments: DeliveryAttachedNemoModel[];
	val_attachments: number;
	private check_id: number;
	id_message_ext: string;

	constructor(model?: any) {
		this.attachments = [];
		if (model) {
			this.date_last_update = model.date_last_update;
			this.date_rec_ins = model.date_rec_ins;
			this.date_read = model.date_read;
			this.flag_active = model.flag_active;
			if (model.id_order && isNumeric(model.id_order)) {
				this.id_order = Number.parseInt(model.id_order);
			}
			this.id_order_message = model.id_order_message;
			this.txt_chassis = model.txt_chassis;
			this.txt_direction = model.txt_direction;
			this.txt_message = model.txt_message;
			this.txt_plate = model.txt_plate;
			this.txt_subject = model.txt_subject;
			this.txt_category = model.txt_category;
			this.user_last_update = model.user_last_update;
			this.user_rec_ins = model.user_rec_ins;
			this.id_sender_ext = model.id_sender_ext;
			this.id_thread = model.id_thread;
			this.txt_context = model.txt_context;
			this.txt_customdata_json = model.txt_customdata_json;
			this.txt_detail = model.txt_detail;
			this.txt_sender_ext = model.txt_sender_ext;
			this.val_attachments = model.val_attachments;
			this.id_message_ext = model.id_message_ext;
		}
	}

	addAttached(attached: DeliveryAttachedNemoModel): void {
		this.attachments.push(attached);
	}

	setCheckId(check_id: number) {
		this.check_id = check_id;
	}

	getCheckId(): number {
		return this.check_id;
	}

	settingFromForm(model?: any) {
		if (model) {
			if (model.id_sender_ext) {
				this.id_sender_ext = model.id_sender_ext;
			}
			if (model.id_order && isNumeric(model.id_order)) {
				this.id_order = Number.parseInt(model.id_order);
			}
			if (model.txt_chassis) {
				this.txt_chassis = model.txt_chassis;
			}
			if (model.txt_category) {
				this.txt_category = model.txt_category;
			}
			if (model.txt_context) {
				this.txt_context = model.txt_context;
			}
			if (model.txt_detail) {
				this.txt_detail = model.txt_detail;
			}
			if (model.txt_direction) {
				this.txt_direction = model.txt_direction;
			}
			if (model.txt_message) {
				this.txt_message = model.txt_message;
			}
			if (model.txt_subject) {
				this.txt_subject = model.txt_subject;
			}
		}
	}

	setDateRead() {
		this.date_read = DateUtilities.getDateNow();
	}
}
